import { useTranslation } from 'next-i18next';
import { Heading } from '@restworld/ui-ds-base';

import EmployerCompanyList from './employer-company-list';
import EmployerCompanyListModal from './modals/employer-company-list-modal';
import EmployerCompanyActionModal from './modals/employer-company-action-modal';
import { SectionHeader, SectionWrapper } from './employer-companies.styled';

function EmployerCompanies() {
  const { t } = useTranslation('payment-and-invoices');

  return (
    <SectionWrapper>
      <SectionHeader>
        <Heading color="neutral">{t('billing_and_payment_method')}</Heading>
      </SectionHeader>
      <EmployerCompanyList context="employer-payments-and-invoices" />
      <EmployerCompanyListModal />
      <EmployerCompanyActionModal />
    </SectionWrapper>
  );
}

export default EmployerCompanies;
